export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/quote_icon_addwatchlist@2x.png";